export default __webpack_public_path__ + "static/29-87b14a079787036f60c6e6b82ab5613b.png";